import { mouseEvent } from "../common/mouse_event";
import BookItem from "../common/bookItem";
import Sticker from "./sticker"
export default class StickerOpen extends BookItem {
    constructor(el, target) {
        super(el, target);

        this.collectSticker = [];
        mouseEvent.add_mouse_event(this);
    }

    init() {
        this.target.gotoAndStop(0);
        this.collectSticker = this.itemControl.getItemsByClassName("sticker", this);
    }

    trigger() {
        this.collectSticker.forEach(sticker => {

            //針對還沒撕開的
            if (sticker.target.currentFrame == 0) {

                sticker.target.gotoAndStop(0);
                sticker.whiteTriangle.visible = false;
                if (!sticker.itemControl.loader.antialiasingMovieClips.includes(sticker.target)) {
                    sticker.itemControl.loader.antialiasingMovieClips.push(sticker.target);
                }

                sticker.target.play();
                sticker.target.loop = 0;

                //不能點了所以關觸碰碰
                sticker.target.mouseEnabled = false;
            }

        });
    }


}